import React, { useContext } from "react";
import { Button } from "simple-ui-components";

import MailOutlineIcon from "@mui/icons-material/MailOutline";

import { SendEmailVerification } from "../../firebase";
import { HeadingOne } from "../../theme";
import { getTranslation, LanguageContext } from "../languageProvider";
import { LayoutLogin } from "../layout/loginPage";
import { ReplaceWord } from "../shared/utility";
import { LoginBox } from "./login";
import { AuthContext } from "../authContextProvider";

const AccountNotActivated = () => {
  const { lang } = useContext(LanguageContext);
  const { snackbarHandler, user } = useContext(AuthContext);

  const resendVerificationEmailHandler = () => {
    SendEmailVerification()
      .then(() => {
        snackbarHandler(
          ReplaceWord(getTranslation("0067"), "**EMAIL**", user.email),
          "success",
          "logout"
        );
      })
      .catch((status) => snackbarHandler(getTranslation(`error${status}`)));
  };
  return (
    <LayoutLogin lang={lang}>
      <LoginBox>
        <HeadingOne marginBottom={10} textCenter data-translate="0159">
          {getTranslation("0159")}
        </HeadingOne>
        <p data-translate="0156">{getTranslation("0156")}</p>
        <Button
          type="submit"
          className="btn-secondary"
          theme="default"
          clicked={resendVerificationEmailHandler}
          icon={<MailOutlineIcon />}
          text={getTranslation("0051")}
          fullWidth={true}
        />
      </LoginBox>
    </LayoutLogin>
  );
};

export default AccountNotActivated;
